import { fetchKioskFilters } from "@actions";
import ExpandButton from "@buttons/ExpandButton";
import OrgTreeButton from "@buttons/OrgTreeButton";
import RefreshButton from "@buttons/RefreshButton";
import OptionsList from "@components/systemAdmin/OptionsList";
import StatusLabels from "@shared/StatusLabels";
import React from "react";
import { connect } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import SummaryButton from "../buttons/SummaryButton.js";

const MachineStatusFilters = (props) => {
  const {
    disabled,
    loading,
    filters,
    onSettingsClick,
    expanded,
    onExpandClick,
    fetchFilter,
    showOrgTree,
    activeRow,
    statuses,
    quantities,
    showSummary,
    onSummaryClick,
    onExportClick,
    exportLoading,
  } = props;

  return (
    <Grid columns="4">
      {filters.length > 0 && (
        <Grid.Row>
          <Grid.Column width="16">
            <OptionsList
              horizontal
              options={filters}
              onChange={props.onFilterChange}
            />
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Grid.Column width="16">
          <OrgTreeButton
            onClick={() => fetchFilter({ showOrgTree: !showOrgTree })}
            active={showOrgTree}
          />
          <SummaryButton
            active={showSummary}
            disabled={loading || disabled}
            onClick={onSummaryClick}
            size="medium"
            className="mb-0"
          />
          <Button
            icon="download"
            disabled={loading || disabled || exportLoading}
            color="teal"
            loading={exportLoading}
            onClick={onExportClick}
          />
          <StatusLabels
            statuses={statuses}
            quantities={quantities}
            onClick={props.onStatusChange}
            disabled={disabled}
          />
          <RefreshButton
            refresh={props.onRefreshClick}
            disabled={disabled}
            loading={props.loading}
          />
          {props.allowAuthorise && (
            <Button
              positive
              loading={props.loading}
              size="small"
              disabled={disabled}
              onClick={props.onAuthoriseClick}
            >
              Authorise
            </Button>
          )}
          {activeRow && activeRow.optionShowSetting && onSettingsClick && (
            <Button
              size="small"
              floated="right"
              className="ml-0_5"
              color="blue"
              disabled={loading || disabled || !activeRow?.installationId}
              icon="cog"
              onClick={onSettingsClick}
            />
          )}
          {onExpandClick && (
            <ExpandButton
              content={expanded ? "Show Details" : "Hide Details"}
              compact={false}
              active={expanded}
              onClick={onExpandClick}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    filters: state.kioskFilters,
  };
};

export default connect(mapStateToProps, { fetchKioskFilters })(
  MachineStatusFilters,
);
